import Api from "@/api/index";
import store from "@/store";
import confirmations from "./confirmations";
import alerts from "@/components/alerts/alert";
import AuthenticationService from "@/services/AuthenticationService";

const schedule = {
  namespaced: true,
  state: {
    all: [],
    datas: {},
    loading: false,
    queryParam: {},
    modalCreate: false,
    modal: false,
    label: "",
    detail: {},
  },
  getters: {
    getDatas(state) {
      return state.datas;
    },
  },
  mutations: {
    SET_ALL(state, datas) {
      state.all = datas;
    },
    SET_DATAS(state, datas) {
      state.datas = datas;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_QUERY_PARAM(state, data) {
      state.queryParam = data;
    },
    SET_MODAL_CREATE(state, data) {
      state.modalCreate = data;
    },
    SET_MODAL(state, data) {
      state.modal = data;
    },
    SET_LABEL(state, data) {
      state.label = data;
    },
    SET_DETAIL(state, data) {
      state.detail = data;
    },
  },
  actions: {
    onRefresh({ state }) {
      store.dispatch("schedule/all", state.queryParam);
    },
    async paginate({ commit }, payload) {
      commit("SET_LOADING", true);
      commit("SET_QUERY_PARAM", payload);
      return await Api.doPaginate("backoffice/schedule/page", payload).then(
        ({ data }) => {
          commit("SET_DATAS", data);
          commit("SET_LOADING", false);
        }
      );
    },
    async all({ commit }, payload) {
      commit("SET_LOADING", true);
      commit("SET_QUERY_PARAM", payload);
      return await Api.doGet("backoffice/schedule", payload)
        .then(({ data }) => {
          commit("SET_ALL", data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          commit("SET_", error.data);
        });
    },
    onAction({ commit }, payload) {
      if (payload[1] === "Create") {
        commit("SET_MODAL_CREATE", true);
      } else if (payload[1] === "Detail") {
        commit("SET_DETAIL", payload[0]);
        commit("SET_MODAL_DETAIL", true);
      }
    },
    tambah({ commit }, payload) {
      commit("SET_LABEL", "Tambah");
      commit("SET_DETAIL", payload);
      commit("SET_MODAL", true);
    },
    edit({ commit }, payload) {
      commit("SET_LABEL", "Update");

      const merge = { ...payload.item, ...payload.hari, ...payload.days };
      Object.assign(merge);
      // console.log(JSON.stringify(merge));
      commit("SET_DETAIL", merge);
      commit("SET_MODAL", true);
    },
    confirmation({ commit }, payload) {
      console.log(JSON.stringify(payload[0]));

      confirmations.confirmationForm(payload[0], `schedule/${payload[1]}`);
    },
    async create({ commit, state }, payload) {
      commit("SET_LOADING", true);
      store.dispatch("loading/setLoading", true);
      return await AuthenticationService.post("backoffice/schedule", payload)
        .then(({ data }) => {
          alerts.sweetalertToast("success", data.message);
          commit("SET_LOADING", false);
          commit("SET_MODAL", false);
          store.dispatch("loading/setLoading", false);
          store.dispatch("schedule/onRefresh");
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          store.dispatch("loading/setLoading", false);
          alerts.sweetalertToast("error", error.response.data.message);
        });
    },
    async delete({ commit, state }, payload) {
      commit("SET_LOADING", true);
      store.dispatch("loading/setLoading", true);
      return await AuthenticationService.delete(
        "backoffice/schedule/" + payload,
        payload
      )
        .then(({ data }) => {
          alerts.sweetalertToast("success", data.message);
          commit("SET_LOADING", false);
          commit("SET_MODAL", false);
          store.dispatch("loading/setLoading", false);
          store.dispatch("schedule/onRefresh");
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          store.dispatch("loading/setLoading", false);
          alerts.sweetalertToast("error", error.response.data.message);
        });
    },
  },
};

export default schedule;
